import { IModelApp } from "@itwin/core-frontend";
import { cMongoTranslator } from "./MongoTranslator";
const axios = require("axios");
enum DbOperation {
  Get = "GET",
  Add = "POST",
  Update = "PATCH",
  Delete = "DELETE",
}

export class cDatabaseApi {
  private static _dbContext: string;

  public static async initDatabaseApi(project: string) {
    //cDatabaseApi._requestContext = await AuthorizedFrontendRequestContext.create();
    this._dbContext = `${process.env.IMJS_BACKEND!}/${project}`;
  }

  private static async getTokenString() {
    const accessToken = await IModelApp.authorizationClient?.getAccessToken();
    if (accessToken) {
      return accessToken;
    }

    return undefined;
  }

  // helper function to for all requests to database service
  private static async makeRequest(
    action: DbOperation,
    query: cDbQuery
  ): Promise<any | undefined> {
    const where = query.getWhereClause();
    console.log(where);
    //
    const mongoTranslator = new cMongoTranslator();
    const queryString = await mongoTranslator.createQuery(query.getWhereObject(), query.operator);

    //
    const url = `${this._dbContext}/${
      query.table[0]
    }?query=${queryString}`;
//Tag=C-|Type=C-

//{Tag: C-|Type=C-}
    var options = {
      method: action,
      body: query.data,
    };
    console.log(options);
    return axios({
      method: options.method,
      url: url,
      data: options.body,
    })
      .then((resp) => {
        if (resp === undefined) return undefined;
        return resp;
      })
      .catch((_reason: any) => {
        console.log("Reason: " + _reason);
        return undefined;
      });
  }

  public static async add(query: cDbQuery): Promise<boolean> {
    const resp = await this.makeRequest(DbOperation.Add, query);
    if (resp.status === 201 || resp.status === 200) {
      return true;
    } else {
      return false;
    }
  }

  public static async query(query: cDbQuery): Promise<cDbIterator> {
    const resp = await this.makeRequest(DbOperation.Get, query);
    const dbIter = new cDbIterator(resp);
    if (resp) {
      dbIter.status = true;
    }

    return dbIter;
  }

  public static async update(query: cDbQuery): Promise<boolean> {
    const resp = await this.makeRequest(DbOperation.Update, query);
    if (resp.status === 200) {
      return true;
    } else {
      return false;
    }
  }

  public static async delete(query: cDbQuery): Promise<boolean> {
    const resp = await this.makeRequest(DbOperation.Delete, query);
    if (resp.status === 204 || resp.status === 200) {
      console.log("ISSUE DELETED");
      return true;
    } else {
      return false;
    }
  }
}

//********************************************************************************
// Iterator for returned data
//********************************************************************************

export class cDbIterator {
  private _body: any;
  private _len: number;
  private _curr: number;
  public status: boolean;

  constructor(resp: any) {
    this._curr = -1;
    this._len = 0;
    this.status = false;
    if (resp) {
      this._body = resp.data;
      this._len = resp.data.length;
    }
  }

  public next(): boolean {
    this._curr++;

    return this._curr < this._len;
  }

  public getCurrent(): any {
    const currObj = this._body[this._curr];
    delete currObj._id; // remove _id added by Mongo

    return currObj;
  }
  
  public getProperty(propName: string) : any {
    const currObj = this.getCurrent();
    if (currObj.hasOwnProperty(propName)) {
      return currObj[propName];
    }

    return undefined;
  }

  public getKeyValues(): Map<string, string> {
    const kvMap: Map<string,string> = new Map(Object.entries(this.getCurrent()));

    return kvMap;
  }

  public getKeys(): Array<string> {
    const keys = Object.keys(this.getCurrent());

    return keys;
  }
} 

//********************************************************************************
// database query
//********************************************************************************

export enum DbCompare {
  Equal = "=",
  LessThan = "<",
  GreateThan = ">",
  LessOrEqual = "<=",
  GreatOrEqual = ">=",
  NotEqual = "<>",
  Like = "LIKE",
}

export enum DbOperator {
  And = "&",
  Or = "|",
  Not = "<>",
}

interface DbCondition {
  property: string;
  value: any;
  operator: DbCompare;
}

export class cDbQuery {
  public table: string[];
  public where: DbCondition[];
  public distinct?: string;
  public operator: DbOperator;  //& | <>
  public delimiter: DbOperator; //&
  public data: any;

  constructor(...table: string[]) {
    this.table = table;
    this.where = [];
    this.operator = DbOperator.And;
    this.delimiter = DbOperator.And;
  }

  public setTable(tableName: string) {
    this.table.push(tableName);
  }

  public setWhere(prop: string, val: any, op: DbCompare = DbCompare.Equal) {
    const cl: DbCondition = {
      property: prop,
      value: val,
      operator: op,
    };

    this.where.push(cl);
  }

  public getWhereObject() {
    const whereObject: any = {};
    this.where.forEach((condition) => {
      whereObject[condition.property] = condition.value;
    });
    
    return whereObject;
  }

  public setOperator(op: DbOperator) {
    this.operator = op;
  }

  public setDistinct(prop: string) {
    this.distinct = prop;
  }

  public setData(data: any) {
    this.data = data;
  }

  public getWhereClause(): string {
    var whereClause = "";

    this.where.forEach((condition) => {
      if (whereClause !== "") whereClause += this.delimiter;
      whereClause += condition.property + condition.operator + condition.value;
    });

    return whereClause;
  }
}
